import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Content = styled.div`
    width:100%;
    padding:1.2rem 2rem;
    background:#fff;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    height:75vh;
    margin-top: 1rem;
    position: relative;
`;

export const TitleLeft = styled.div`
    display:flex;
    flex-direction: row;
    gap:1rem;
    justify-content: space-between;
    align-self: end;
    span:nth-of-type(1){
        font-size: 20px;
        font-weight: 600;
    }
    span:nth-of-type(2){
        color:#414141;
        font-size: 14px;
        font-weight: 500;
        height: 100%;
        margin-top: auto;
    }
`;

export const DataListWrap = styled.div`
    height:calc(100% - 98px );
    overflow:auto;  
    scrollbar-width: thin;

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: darkgrey;
    }
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
`;

export const DashList = styled.table`
    width:100%;
    margin-top: 1rem;
    border-collapse: collapse;

    td{
        font-size: 14px;
        padding:5px 10px;

    }

    tr:nth-of-type(even){
            background:#a7a7a71f;
    }

    span{
        display:block;
        white-space: nowrap;
    }

    .width15{
        width:280px;
        min-width: 280px;
        max-width:280px;
    }

    .width10{
        width:150px;
        min-width: 150px;
    }
    .width5{
        width:120px;
        min-width: 120px;
    }
`;

export const Td = styled.td<{}>`
    font-size: 16px !important;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    font-weight: 600;
    white-space: nowrap;
    svg{
        height:14px;
    }
    &:hover{
        background:#f8f8f8;
    }
`;

export const Img = styled.div`
    width:28px;
    height:28px; 
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
`;

export const PickButton = styled.button`
    font-size: 12px;
    font-weight: 400;
    background:#2A848E;
    color:#fff;
    padding:0.5rem 1rem;
    border-radius: 20px;
    white-space: nowrap;

    &:hover{
        opacity: 0.8;
    }
`;

export const ActionBar = styled.div`
    display:flex;
    gap:1rem;
    margin-left: auto;
    justify-content: end;

    svg{
        cursor: pointer;
        height:18px;

        path{
            fill:#888888;
        }

        :hover{
            opacity: 0.8;
        }
    }
`;

export const MoreTags = styled.div`
    height:23px; 
    width:23px;
    border-radius: 5px;
    display:flex;
    align-items: center;
    justify-content: center;
    svg{
        margin-left: 2px;
        width:70%;
    }
`;